import { CellProps } from 'react-table'
import { FormularioAtendimentoList } from '../../../avaliacoes-pendentes-list/core/_models'
import { useQueryRequest } from '../../core/QueryRequestProvider'
import { PlainHeader, sortableColumn, StackedCell, TableColumn } from '../../../../../../components'
import { AvaliacoesActionsCell } from './AvaliacoesActionsCell'
import { AvaliacoesSelectionHeader } from './AvaliacoesSelectionHeader'
import { AvaliacoesSelectionCell } from './AvaliacoesSelectionCell'
import { TFunction } from '_metronic/i18n/Metronici18n'

/** Enum da situação ("ASSINADO") → rótulo ("Assinado"). */
const situacaoLabel = (situacao?: string) =>
  situacao
    ?.trim()
    .toLowerCase()
    .replace(/^./, (char) => char.toUpperCase())

export const avaliacoesColumns = (
  t: TFunction
): ReadonlyArray<TableColumn<FormularioAtendimentoList>> => [
  {
    Header: () => <AvaliacoesSelectionHeader />,
    id: 'selection',
    cellWidth: '48px',
    Cell: ({ row }: CellProps<FormularioAtendimentoList>) => (
      <AvaliacoesSelectionCell
        atendimentoId={row.original.atendimento?.id}
        formularioAtendimentoId={row.original.id}
        ariaLabel={`Selecionar avaliação de ${row.original.paciente?.nome ?? ''}`}
      />
    ),
  },
  sortableColumn<FormularioAtendimentoList>({
    id: 'atendimento.paciente.pessoa.nome',
    useQueryRequest,
    fields: [{ field: 'atendimento.paciente.pessoa.nome', label: t('cols.paciente') }],
    Cell: ({ row }: CellProps<FormularioAtendimentoList>) => (
      <StackedCell primary={row.original.paciente?.nome} />
    ),
  }),
  sortableColumn<FormularioAtendimentoList>({
    id: 'atendimento.protocolo',
    cellWidth: '160px',
    useQueryRequest,
    fields: [{ field: 'atendimento.protocolo', label: t('cols.protocolo') }],
    Cell: ({ row }: CellProps<FormularioAtendimentoList>) => (
      <StackedCell tabular primary={row.original.atendimento?.protocolo} />
    ),
  }),
  // Avaliação (formulário) com a especialidade do atendimento como apoio.
  sortableColumn<FormularioAtendimentoList>({
    id: 'formulario.nome',
    useQueryRequest,
    fields: [
      { field: 'formulario.nome', label: 'Avaliação' },
      { field: 'atendimento.especialidade.nome', label: t('cols.especialidade') },
    ],
    Cell: ({ row }: CellProps<FormularioAtendimentoList>) => (
      <StackedCell
        primary={row.original.formulario?.nome}
        secondary={row.original.atendimento?.especialidade?.nome}
      />
    ),
  }),
  // Situação com a data de finalização como apoio (ordem padrão: mais recente primeiro).
  sortableColumn<FormularioAtendimentoList>({
    id: 'data',
    cellWidth: '200px',
    hideOnMobile: true,
    useQueryRequest,
    fields: [
      { field: 'situacao', label: t('situacao.label') },
      { field: 'data', label: 'Finalização' },
    ],
    Cell: ({ row }: CellProps<FormularioAtendimentoList>) => (
      <StackedCell
        primary={situacaoLabel(row.original.situacao)}
        secondary={row.original.dataFormatada}
      />
    ),
  }),
  {
    Header: () => <PlainHeader>{t('cols.actions')}</PlainHeader>,
    id: 'actions',
    cellWidth: '96px',
    align: 'end',
    Cell: ({ row }: CellProps<FormularioAtendimentoList>) => (
      <AvaliacoesActionsCell formularioAtendimento={row.original} />
    ),
  },
]
